import React from 'react';
import { Link } from 'react-router-dom';
import { isMobile, isTablet, useMobileOrientation } from 'react-device-detect';
import Grid from '@mui/material/Grid';
import DataDisplay from './DataDisplay';
import IntroDisplay from './IntroDisplay';
import '../Disclaimer.css';
import './Petrochemical.css';

const petrochemicals = require('../data/petrochemical.json');
const hotspot = require('../data/petrohotspots.json');

const Petrochemical = (props) => {
  
  const cm = "fade-in cm-imagemap__hotzone cm-imagemap__hotzone--icon";
  const { isPortrait } = useMobileOrientation();

  return (
      <div className="main-wrapper fade-in">
        <Grid container style={{ backgroundColor: '#F0F0F0' }}>
          <Grid item xs={12} sm={12} md={8}>
            <div className="main-img">
              <img src="images/updated-plant-image.jpg" alt="Petrochemical Plant" />
              { isMobile ? 
                isTablet ? 
                  hotspot.map((h, index) => {
                    return (
                      <div id="hotspot-div" key={index}>
                        <Link to={`/#${h.data.title}`}>                      
                          <span 
                            key={h.id} 
                            id={h.id} 
                            onClick={() => props.handleSelection(h.id)} 
                            className={`${cm}${h.id}`} 
                            style={{top: `${h.coordinates.tablet.values[0]}%`, left: `${h.coordinates.tablet.values[1]}%`}}
                          />
                        </Link>
                      </div>
                    )
                  })
                : 
                  hotspot.map((h, index) => {
                    if (isPortrait) {
                      return (
                        <div id="hotspot-div" key={index}>
                          <Link to={`/#${h.data.title}`}>                        
                            <span 
                              key={h.id} 
                              id={h.id} 
                              onClick={() => props.handleSelection(h.id)} 
                              className={`${cm}${h.id}`} 
                              style={{top: `${h.coordinates.mobile.portrait[0]}%`, left: `${h.coordinates.mobile.portrait[1]}%`}}
                            />
                          </Link>
                        </div>
                      )
                    } else {
                      return (
                        <div id="hotspot-div" key={index}>
                          <Link to={`/#${h.data.title}`}>                        
                            <span 
                              key={h.id} 
                              id={h.id} 
                              onClick={() => props.handleSelection(h.id)} 
                              className={`${cm}${h.id}`} 
                              style={{top: `${h.coordinates.mobile.values[0]}%`, left: `${h.coordinates.mobile.values[1]}%`}}
                            />
                          </Link>
                        </div>
                      )
                    }
                  })
              :
                hotspot.map((h, index) => {
                  return (
                    <div id="hotspot-div fade-in" key={index}>
                      <Link to={`/#${h.data.title}`}>
                        <span 
                          key={h.id} 
                          id={h.id} 
                          onClick={() => props.handleSelection(h.id)} 
                          className={`${cm}${h.id}`} 
                          style={{ top: `${h.coordinates.desktop.values[0]}%`, left: `${h.coordinates.desktop.values[1]}%`}} 
                        />
                      </Link>
                    </div>
                  )
                }) 
              }
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <div className="main-col fade-in">
              { props.selection === petrochemicals[0].id ? 
                <IntroDisplay key={petrochemicals[0].id} keyId={petrochemicals[0].id} hotspotData={petrochemicals[0].data} />
              : 
                <DataDisplay key={hotspot[props.selection-1].id} keyId={hotspot[props.selection-1].id} hotspotData={hotspot[props.selection-1].data} />
              }
            </div>
          </Grid>

          <Grid item xs={12} className="disclaimerHome">
               <small  className="disclaimer">The contents of this Solution Advisor are presented for informational purposes only, and while effort has been made to ensure their accuracy, they are not to be construed as warranties or guarantees, express or implied, regarding the products or services described herein or their use or applicability. </small>
 
          </Grid>
        </Grid>
      </div>
  )
}

export default Petrochemical;